import { HttpErrorResponse } from '@angular/common/http'
import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core'
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { BehaviorSubject } from 'rxjs'
import { STORAGE_TOKEN, STORAGE_USER_LOGIN } from 'src/app/app-settings'
import { LoginService } from '../services/login.service'

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  @ViewChild('codeSubmit') codeSubmit: ElementRef

  constructor(
    private loginService: LoginService,
    private router: Router,
    private formBuilder: FormBuilder,
    private renderer: Renderer2,
  ) {}

  get fLogin(): { [key: string]: AbstractControl } {
    return this.loginForm.controls
  }
  get fPin(): { [key: string]: AbstractControl } {
    return this.pinForm.controls
  }
  get fForgot(): { [key: string]: AbstractControl } {
    return this.forgotForm.controls
  }

  showLogin: boolean
  showAuthentication: boolean
  showForgot: boolean
  loginForm: FormGroup
  loginSubmitted: boolean
  pinForm: FormGroup
  forgotForm: FormGroup
  pinSubmitted: boolean
  testindex
  forgotSubmitted: boolean
  wrongCredentiels: boolean
  somethingWentWrong: boolean
  wrongPin: boolean
  isWaitingResponse = new BehaviorSubject(false)
  alreadyLoggedIn: boolean
  wrongforgot: boolean
  pinCode = ''
  UserLoggedIn: string
  emailSent: boolean

  ngOnInit(): void {
    if (localStorage.getItem(STORAGE_USER_LOGIN) && localStorage.getItem(STORAGE_TOKEN)) {
      this.alreadyLoggedIn = true
      this.UserLoggedIn = localStorage.getItem(STORAGE_USER_LOGIN)
    } else {
      this.toggleLogin()
    }

    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(8)]],
    })

    this.pinForm = this.formBuilder.group({
      pin1: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      pin2: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      pin3: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      pin4: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      pin5: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      pin6: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
    })

    this.forgotForm = this.formBuilder.group({
      identifier: ['', Validators.required],
    })
  }

  onLogin(): void {
    this.loginSubmitted = true
    this.uncheckErrors()

    if (this.loginForm.invalid) {
      return
    }

    this.isWaitingResponse.next(true)

    this.loginService.loginBeforeAuth(this.fLogin.username.value.toLowerCase(), this.fLogin.password.value).subscribe({
      next: () => {
        this.isWaitingResponse.next(false)
        this.toggleAuthentication()
      },
      error: (err) => {
        this.isWaitingResponse.next(false)
        if (err instanceof HttpErrorResponse && err.status === 401) {
          this.wrongCredentiels = true
        } else {
          this.somethingWentWrong = true
        }
      },
    })
  }

  onCodeChanged(code: string): void {}

  onCodeCompleted(code: string): void {
    this.pinCode = code
    this.codeSubmit.nativeElement.focus()
  }

  onAuthenticate(): void {
    this.isWaitingResponse.next(true)
    this.uncheckErrors()

    const pinString = this.pinCode

    this.loginService.authenticationRespons(this.fLogin.username.value.toLowerCase(), pinString).subscribe({
      next: () => {
        this.loginService.loginAfterAuth(this.fLogin.username.value.toLowerCase(), this.fLogin.password.value).subscribe({
          next: () => {
            this.isWaitingResponse.next(false)
            this.loginService.setWebInternalUser(localStorage.getItem(STORAGE_USER_LOGIN)).subscribe()
            this.router.navigate(['/main/general'])
          },
          error: () => {
            this.isWaitingResponse.next(false)
            this.somethingWentWrong = true
          },
        })
      },
      error: (err) => {
        this.isWaitingResponse.next(false)
        if (err instanceof HttpErrorResponse && err.status === 401) {
          this.wrongPin = true
          this.toggleLogin()
        } else {
          this.somethingWentWrong = true
        }
      },
    })
  }
  onForgot(): void {
    this.forgotSubmitted = true
    this.uncheckErrors()

    if (this.forgotForm.invalid) {
      return
    }

    this.isWaitingResponse.next(true)

    this.loginService.forgotPasswordWebinternal(this.fForgot.identifier.value.toLowerCase()).subscribe({
      next: () => {
        this.isWaitingResponse.next(false)
        this.emailSent = true
      },
      error: () => {
        this.isWaitingResponse.next(false)
        this.wrongforgot = true
      },
    })
  }

  onClickForgotPassword(): void {
    this.toggleForgot()
  }

  keytap(event): boolean {
    if (!(event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) {
      return false
    }
    const element = event.srcElement.nextElementSibling

    if (!element) {
      return
    } else {
      ;(element as any)?.focus?.apply(element, [])
    }
  }

  backtap(event): void {
    const element = event.srcElement.previousElementSibling

    if (!element) {
      return
    } else {
      element.focus()
    }
  }

  toggleLogin(): void {
    this.alreadyLoggedIn = false
    this.showAuthentication = false
    this.showLogin = true
    this.showForgot = false
  }

  toggleAuthentication(): void {
    this.showAuthentication = true
    this.showLogin = false
    this.showForgot = false
  }

  toggleForgot(): void {
    this.showForgot = true
    this.showAuthentication = false
    this.showLogin = false
    this.emailSent = false
  }

  uncheckErrors(): void {
    this.wrongCredentiels = false
    this.somethingWentWrong = false
    this.wrongPin = false
    this.wrongforgot = false
  }

  continue(): void {
    this.router.navigate(['/main/general'])
  }

  signOut(): void {
    this.loginService.logout(this.UserLoggedIn).subscribe(() => {
      localStorage.removeItem(STORAGE_USER_LOGIN)
      localStorage.removeItem(STORAGE_TOKEN)
      this.toggleLogin()
    })
  }
}
